import React from 'react';

import { MAX_BINGO_SCHEDULER_COUNT } from '@interlayer/js/app/components/main/Skeleton/constants';
import { TBingoSchedulerProps } from '@interlayer/js/app/components/main/Skeleton/types';
import { clsx } from '@interlayer/js/app/utils/clsx.util';

import style from './BingoScheduler.scss';
import styleScroller from '@interlayer/js/app/components/common/Scroller/Scroller.scss';
import styleBingoTile from '@interlayer/js/app/components/main/Games/components/GameTile/components/BingoTile/BingoTile.scss';

export const BingoScheduler: React.FC<TBingoSchedulerProps> = ({ count = 1, withTitle }) => (
    <>
        {withTitle && (
            <div className={style.titleWrapper}>
                <div className={style.title} />

                <div className={style.link} />
            </div>
        )}

        <div className={styleScroller.scrollContainer}>
            <div className={styleScroller.container}>
                {Array.from({ length: count <= MAX_BINGO_SCHEDULER_COUNT
                    ? count
                    : MAX_BINGO_SCHEDULER_COUNT
                }, (_, index) => (
                    <div key={index} className={clsx(style.item, styleBingoTile.inlineContainer)} />
                ))}
            </div>
        </div>
    </>
);
